import React, { Component } from "react";
import { Table, Accordion } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import CheckIcon from "../../../assets/images/check_36x36.png";
import LandlineIcon from "../../../assets/images/landline.png";
import CellIcon from "../../../assets/images/cell.png";
import pickDeep from "../../../utils/nodeUtil";
import AttIcon from "../../../assets/images/carriers/att.jpg";
import SwbellIcon from "../../../assets/images/carriers/SwBell.png";
import Verizoncon from "../../../assets/images/carriers/verizon.jpg";
import SprintIcon from "../../../assets/images/carriers/sprint.jpg";
import TmobileIcon from "../../../assets/images/carriers/t-mobile.jpg";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import { getNodeValue } from "../../common/Utils";
import { getMonthAndYear } from "../../common/DisplayDate";

class PlatinumAddressHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
  }

  state = {
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadAddress(nextProps);
    }
  }

  getPhoneCarrierImage = (name) => {
    if (name.indexOf("att") !== -1 || name.indexOf("Blue Licenses") !== -1) {
      return AttIcon;
    }
    if (name.indexOf("BELLSOUTH") !== -1) {
      return SwbellIcon;
    }
    if (name.indexOf("erizon") !== -1 || name.indexOf("ERIZON") !== -1) {
      return Verizoncon;
    }
    if (name.indexOf("Sprint") !== -1 || name.indexOf("SPRINT") !== -1) {
      return SprintIcon;
    }
    if (name.indexOf("T-Mobile") !== -1 || name.indexOf("T-MOBILE") !== -1) {
      return TmobileIcon;
    }
    return "";
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadAddress = (props) => {
    const addresses = _.get(props.node, "addresses[0].address");
    let primaryAddresses = [];
    let secondaryAddresses = [];
    _.forEach(addresses, (address) => {
      const firstDate = _.get(address, "firstDate");
      const lastDate = _.get(address, "lastDate");
      const dateFrom =
        getNodeValue(address, "dateFrom") ||
        (firstDate && getMonthAndYear(firstDate[0])) ||
        "";
      const dateTo =
        getNodeValue(address, "dateTo") ||
        (lastDate && getMonthAndYear(lastDate[0])) ||
        "";
      const dateFromUpdatedRaw = dateFrom;
      if (dateFromUpdatedRaw !== undefined) {
        const tokens = dateFromUpdatedRaw.split("/");
        if (tokens.length > 1) {
          const monthInt = parseInt(tokens[0], 10);
          address.dateFromUpdatedRaw = Number(`${tokens[1]}${monthInt < 10 ? "0" : ""}${monthInt}`);
        }
      }
      const dateToUpdatedRaw = dateTo;
      if (dateToUpdatedRaw !== undefined) {
        const tokens = dateToUpdatedRaw.split("/");
        if (tokens.length > 1) {
          const monthInt = parseInt(tokens[0], 10);
          address.dateToUpdatedRaw = Number(`${tokens[1]}${monthInt < 10 ? "0" : ""}${monthInt}`);
        }
      }
      if (_.get(address, "recordType[0]") === "secondary") {
        secondaryAddresses.push(address);
      } else {
        primaryAddresses.push(address);
      }
    });
    primaryAddresses = _.orderBy(
      primaryAddresses,
      ["dateToUpdatedRaw", "dateFromUpdatedRaw"],
      ["desc", "desc"]
    );
    secondaryAddresses = _.orderBy(
      secondaryAddresses,
      ["dateToUpdatedRaw", "dateFromUpdatedRaw"],
      ["desc", "desc"]
    );
    const primaryAddressNodes = [];
    this.addAddressRows(primaryAddresses, primaryAddressNodes, "prim");
    const secondaryAddressNodes = [];
    this.addAddressRows(secondaryAddresses, secondaryAddressNodes, "sec");
    this.setState({ primaryAddressNodes, secondaryAddressNodes });
    props.updateItemCountBySection(
      props.sectionName,
      primaryAddressNodes.length
    );
  };

  addAddressRows = (addresses, rows, type) => {
    _.forEach(addresses, (address, addIndex) => {
      let recType = getNodeValue(address, "recordType");
      if (!recType && type === "prim") recType = "prim";
      if (recType) {
        let phoneInfos = [];
        const phones = _.get(address, "phones");
        if (phones)
          phones.forEach((phone) => {
            const currPhoneInfos = [];
            pickDeep(phone, "phoneInfo", currPhoneInfos);
            phoneInfos.push(currPhoneInfos);
          });
        phoneInfos = _.flatten(phoneInfos);
        const cells = [];
        const firstDate = _.get(address, "firstDate[0]");
        const lastDate = _.get(address, "lastDate[0]");
        const dateFrom =
          getNodeValue(address, "dateFrom") ||
          (firstDate && firstDate !== "" && getMonthAndYear(firstDate)) ||
          "";
        const dateTo =
          getNodeValue(address, "dateTo") ||
          (lastDate && lastDate !== "" && getMonthAndYear(lastDate)) ||
          "";
        cells.push(
          <Table.Cell width={2} key={`Person_Record_Date_Cell_${addIndex}`}>
            {`${dateFrom || ""}-${dateTo || ""}`}
          </Table.Cell>
        );
        cells.push(
          <Table.Cell width={1} key={`Person_Record_Check_Cell_${addIndex}`}>
            {(recType === "Best" ||
              recType === "V" ||
              recType === "C" ||
              recType === "ncoa") && <img src={CheckIcon} alt="check" />}
          </Table.Cell>
        );
        const fullAddress =
          getNodeValue(address, "fullAddress") ||
          getNodeValue(address, "line1");
        cells.push(
          <Table.Cell width={5} key={`Person_Record_Address_Cell_${addIndex}`}>
            <Address
              addressNode={address}
              {...this.props}
              fullAddress={fullAddress}
              ignoreLine1
            />
          </Table.Cell>
        );
        const items = [];
        if (phoneInfos.length > 0) {
          _.forEach(_.flatten(phoneInfos), (phoneInfo, addSubIndex) => {
            let displayContent = "";
            const score = _.get(phoneInfo, "score[0]");
            if (!score && _.get(phoneInfo, "phone[0]._", "") !== "") {
              let phoneIcon = LandlineIcon;
              if (_.get(phoneInfo, "phone[0]._", "") === "WIRELESS") {
                phoneIcon = CellIcon;
              }
              const phone10 = _.get(
                phoneInfo,
                "enhancedPhoneInfo[0].phone10[0]._",
                ""
              );
              const phone = _.get(phoneInfo, "phone[0]._", "");
              if (phone10.length > 6) {
                const listedName = _.get(
                  phoneInfo,
                  "enhancedPhoneInfo[0].listedName[0]._",
                  ""
                );
                displayContent = phone10;
                if (listedName !== "") {
                  displayContent = `${displayContent} Listed : ${listedName} `;
                }
                const descriptions = [];
                pickDeep(phoneInfo, "description", descriptions);
                _.forEach(descriptions, (description) => {
                  displayContent = `${displayContent}[${description[0]._}]`;
                });
              } else if (phone.length > 6) {
                displayContent = phone;
              } else {
                const phoneInfo2 = _.get(address, "phoneInfo[1].phone[0]._");
                if (phoneInfo2 !== undefined) {
                  displayContent = phoneInfo2;
                }
              }
              if (displayContent !== "") {
                const carrierInfo = _.get(phoneInfo, "phoneCarrier[0]._", "");
                const carrierIcon = this.getPhoneCarrierImage(carrierInfo);

                items.push(
                  <img
                    key={`img_phone_${addIndex}_${addSubIndex}_${type}`}
                    src={phoneIcon}
                    width="32px"
                    height="32px"
                    alt="PhoneIcon"
                  />
                );
                items.push(
                  <span key={`disp_content_${addIndex}_${addSubIndex}_${type}`}>
                    {displayContent}
                  </span>
                );
                if (carrierIcon !== "")
                  items.push(
                    <img
                      key={`img_carrier_${addIndex}_${addSubIndex}_${type}`}
                      src={carrierIcon}
                      alt="carrierImage"
                      width="32px"
                      height="32px"
                    />
                  );
                else if (carrierInfo !== "") {
                  items.push(
                    <span key={`car_info_${addIndex}_${addSubIndex}_${type}`}>
                      {" "}
                      {carrierInfo}
                    </span>
                  );
                }

                items.push(
                  <br key={`br_${addIndex}_${addSubIndex}_${type}`} />
                );
              }
            }
          });
        }
        cells.push(
          <Table.Cell width={7} key={`Person_Record_Detail_Cell_${addIndex}`}>
            {items}
          </Table.Cell>
        );

        rows.push(
          <Table.Row key={`Person_Record_Address_Row_${addIndex}_${type}`}>
            {cells}
          </Table.Row>
        );
      }
    });
  };

  render() {
    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`AddressPTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Address History
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`AddressPBody`}
          active={this.state.activeIndex === 0}
        >
          <Table className={"table-custom-strip"}>
            <Table.Body>
              {this.state && this.state.primaryAddressNodes}
            </Table.Body>
          </Table>
          {this.state &&
            this.state.secondaryAddressNodes &&
            this.state.secondaryAddressNodes.length > 0 && (
              <SimpleAccordionContent
                {...this.props}
                name={"Additional Address History From Secondary Sources"}
                rows={this.state.secondaryAddressNodes}
                additionalClasses={"table-custom-strip"}
              />
              // <Table>
              //   <Table.Body>
              //     <Table.Row>
              //       <Table.Cell
              //         colSpan={6}
              //         className="report-sub-section-header"
              //       >
              //         Additional Address History From Secondary Sources
              //       </Table.Cell>
              //     </Table.Row>
              //     {this.state && this.state.secondaryAddressNodes}
              //   </Table.Body>
              // </Table>
            )}
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default PlatinumAddressHistory;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/PlatinumAddressHistory.js